/* eslint-disable @typescript-eslint/no-unsafe-member-access */
export function assertString(input: any) {
  const isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    let invalidType = typeof input;
    // the origin function has - invalidType = 'null' as string not an object
    if (input === null) invalidType = 'undefined';
    else if (invalidType === 'object') invalidType = input.constructor.name;

    throw new TypeError(`Expected a string but received a ${invalidType}`);
  }
}

function isLuhnValid(str: string) {
  assertString(str);
  const sanitized = str.replace(/[- ]+/g, '');
  let sum = 0;
  let digit;
  let tmpNum;
  let shouldDouble;
  for (let loop = sanitized.length - 1; loop >= 0; loop--) {
    digit = sanitized.substring(loop, loop + 1);
    tmpNum = parseInt(digit, 10);
    if (shouldDouble) {
      tmpNum *= 2;
      if (tmpNum >= 10) {
        sum += (tmpNum % 10) + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }
    shouldDouble = !shouldDouble;
  }
  return !!(sum % 10 === 0 ? sanitized : false);
}

/* eslint-disable max-len */
const creditCard =
  /^(?:4[0-9]{12}(?:[0-9]{3,6})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12,15}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14}|^(81[0-9]{14,17}))$/;
/* eslint-enable max-len */

export default function isCreditCard(str: string) {
  assertString(str);
  const sanitized = str.replace(/[- ]+/g, '');
  if (!creditCard.test(sanitized)) {
    return false;
  }
  return isLuhnValid(str);
}
